import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function CustomerProtectedRoute({ children }) {
  const { user, booting } = useAuth();
  const loc = useLocation();
  if (booting) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-muted-foreground" data-testid="customer-boot">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to={`/login?redirect=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  return children;
}
